import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";

function* getGameConfigurations(action) {
    try {
        let search = {};
        if (action.payload.subsidiary)
            search["subsidiary"] = action.payload.subsidiary;
        if (action.payload.gameEngine)
            search["gameEngine"] = action.payload.gameEngine;
        if (action.payload.status !== undefined && action.payload.status !== "")
            search["status"] = action.payload.status;

        const configurations = yield call(() =>
            gamesAPI.getGameConfigs({
                skip: (action.payload.page - 1) * action.payload.top,
                top: action.payload.top,
                search: search,
                gameId: action.payload.gameId
            })
        );

        yield put({
            type: GamesActionTypes.GET_GAME_CONFIGURATIONS_SUCCESS,
            payload: {
                configurations: configurations.data
            }
        });
    } catch (e) {
        API.handleError(e.response, "Error getting game list.");

        yield put({
            type: GamesActionTypes.GET_GAME_CONFIGURATIONS_FAIL,
            message: e.message
        });
    }
}

export function* getGameConfigurationsWatcher() {
    yield takeLatest(
        GamesActionTypes.GET_GAME_CONFIGURATIONS,
        getGameConfigurations
    );
}
